export const CONTRACT_PERIOD = {
  MONTHLY: {
    key: 'MONTHLY',
    name: 'Bulan',
  },
  YEARLY: {
    key: 'YEARLY',
    name: 'Tahun',
  },
}

const contractPeriods = [
  {
    key: 'MONTHLY',
    name: 'Bulan',
  },
  {
    key: 'YEARLY',
    name: 'Tahun',
  },
]

export default contractPeriods;